import styled from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import Box from '@deprecated-ui/statics/Box';

const NavigationWrapper = styled.div`
  margin-right: 24px;
  width: 130px;
`;

const Menu = styled(Text).attrs({ as: 'a', size: '14.5px' })`
  display: block;
  line-height: 30px;
  width: 130px;

  @media screen and (max-width: 600px) {
    width: 100px;
  }
`;

const GoogleMap = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
`;

const ArticleBox = styled(Box)`
  margin: 0 auto;

  @media screen and (min-width: 740px) {
    max-width: 740px;
  }
`;

const ArticleContainer = styled.article`
  font-size: 14.5px;
  width: 100%;
  ul {
    padding-left: 20px;
  }

  ol {
    padding-left: 20px;
  }

  p + ul {
    margin-top: -10px;
  }

  h3 {
    font-weight: normal;
  }
`;

export { NavigationWrapper, Menu, GoogleMap, ArticleBox, ArticleContainer };
